<script>
import Logs from "../log/logs";
import {
  PAGE_PADDING,
  PAGE_TOOLBARS_HEIGHT,
  PAGE_FOOTER_HEIGHT,
  GRID_HEADER_HEIGHT,
  GRID_FILTER_ROW_HEIGHT,
  GRID_FILTER_PANEL_HEIGHT,
  GRID_PAGER_HEIGHT
} from '@/shared/consts/layout';

export default {
  name: 'AgentLogs',
  extends: Logs,
  props: ['id'],
  components: { Logs },
  data() {
    return {
      showGroup: false,
    };
  },
  computed: {
    sumGap() {
      const tabListHeight = 37;
      const appButtonsHeight = 47;
      const padding = 60;
      return PAGE_PADDING + PAGE_TOOLBARS_HEIGHT + PAGE_FOOTER_HEIGHT + tabListHeight + appButtonsHeight + padding;
    },
    gridHeight() {
      const appHeightSize = this.$store.getters.appContainerSize.height;
      return (appHeightSize || 800) - this.sumGap;
    },
    gridBodyHeight() {
      return this.gridHeight - GRID_HEADER_HEIGHT - GRID_FILTER_ROW_HEIGHT - (this.showFilterPanel ? GRID_FILTER_PANEL_HEIGHT : 0) - GRID_PAGER_HEIGHT;
    },
  },
  methods: {
    agentLogRoute(id) {
      const route = {
        name: "log",
        params: { id }
      };

      if (this.isCloudMode && !this.aclUser.hasDefaultLocation()) {
        route.query = { context: "agent-logs" };
      }

      return route;
    },
    onRowClick(e) {
      if (window.getSelection().focusOffset !== window.getSelection().anchorOffset)
        return;

      const route = this.agentLogRoute(e.data.id);

      if (e.event.metaKey || e.event.ctrlKey) {
        const routeData = this.$router.resolve(route);
        window.open(routeData.href, "_blank");
      } else {
        this.$router.push(route);
      }
    },
    stateLoad() {
      let state = this.$store.getters.gridStateAgentLogs;
      if (!state)
        state = {
          pageIndex: 0,
          pageSize: this.countRows(this.gridBodyHeight)
        };

      if (!this.pageSize.includes(state.pageSize))
        state.pageSize = this.countRows(this.gridBodyHeight);

      return state;
    },
    stateSave(state) {
      return this.$store.commit("setGridStateAgentLogs", state);
    },
    beforeQueryData(query) {
      if (query.filterJson) {
        query.filterJson = [query.filterJson, "and", [['objectClass', '=', 'AgentDao'], 'and', ['objectId', '=', this.id]]];
      } else {
        query.filterJson = [['objectClass', '=', 'AgentDao'], 'and', ['objectId', '=', this.id]];
      }
    },
    updateBreadcrumbAndTitle() {
    }
  },
  watch: {
    id() {
      this.$refs.dataGrid.instance.refresh();
    }
  }
};
</script>
